import { DeliveryBoxIcon } from "~/components/icons/16/DeliveryBoxIcon";
import { ThicknessIcon } from "~/components/icons/16/ThicknessIcon";
import { YarnIcon } from "~/components/icons/16/YarnIcon";
import { FacebookIcon } from "~/components/icons/24/FacebookIcon";
import { InstagramIcon } from "~/components/icons/24/InstagramIcon";
import { LinkedInIcon } from "~/components/icons/24/LinkedInIcon";
import { PinterestIcon } from "~/components/icons/24/PinterestIcon";
import { PlayIcon } from "~/components/icons/24/PlayIcon";
import { StrikkefasthetIcon } from "~/components/icons/24/StrikkefasthetIcon";
import { TwitterIcon } from "~/components/icons/24/TwitterIcon";
import { YoutubeIcon } from "~/components/icons/24/YoutubeIcon";
import type { MediaCardStoryblok } from "~/generated/sb/blok-types";

export const SomeIcon = ({ socialIcon }: { socialIcon: MediaCardStoryblok["socialIcon"] }) => {
	if (!socialIcon || typeof socialIcon !== "string") return null;
	switch (socialIcon?.toLowerCase()) {
		case undefined:
		case null:
		case "":
			return null;
		case "instagram":
			return <InstagramIcon />;
		case "linkedin":
			return <LinkedInIcon />;
		case "facebook":
			return <FacebookIcon />;
		case "twitter":
			return <TwitterIcon />;
		case "youtube":
			return <YoutubeIcon />;
		case "pinterest":
			return <PinterestIcon />;
		case "play":
			return <PlayIcon />;
		case "deliverybox":
			return <DeliveryBoxIcon />;
		case "strikkefasthet":
			return <StrikkefasthetIcon />;
		case "thickness":
			return <ThicknessIcon />;
		case "yarn":
			return <YarnIcon />;
		default:
			return null;
	}
};
